#import "../fragments/inbox-assignment-fragment.graphql"
#import "../fragments/inbox-message-fragment.graphql"

fragment InboxChannelEventFragment on TimelineEvent {
    changeTime
    changeType
    changeTime
    changes {
        id
        attribute
        oldValue
        newValue
    }
    actor {
        ... on User {
            id
            name
        }
        ... on Contact {
            name
        }
        ... on Origin {
            id
            name
        }
    }
    payload {
        __typename
        ... on Assignment {
            ...InboxAssignmentFragment
        }
        ... on Thread {
            id
            createdTime
            closedTime
            threadType
            startedFromUrl {
                id
                fullyQualifiedUrl
                pageTitle
                path
            }
        }
        ... on Message {
            ...InboxMessageFragment
        }
        ... on Note {
            body
            bodyHtml
        }
    }
}
